<template>
  <span class="item" :class="{ 'has-image': withImage }" dir="ltr">
    <img
      v-if="withImage"
      :src="`/api/image/get/menu/small/${item.image}`"
      loading="lazy"
      alt="item"
      class="w-full h-60 object-cover"
      style="width: 320px; height: auto; padding-bottom: 4.2rem !important;"
      @click="$emit('toggleModal', item, sectionId)"
    />

    <div class="multi-image-icon" v-if="item.imagesCode && item.imagesCode.length > 1">
      <img src="@/assets/icons/multiImages.svg" height="20" />
    </div>

    <div class="heart-icon" >
      <img
        v-if="isInWishlist(item.id)"
        src="@/assets/icons/heart-full-red.svg"
        class="ml-2"
        style="height: 30px; width: 30px;"
        @click.stop="$emit('removeFromWishlist', item.id)"
      />
      <img
        v-else
        src="@/assets/icons/heart-red.svg"
        style="height: 30px; width: 30px;"
        class="ml-2"
        @click.stop="$emit('addToWishlist', item.id)"
      />
    </div>

    <div
      class="add-to-cart-icon-in-image"
      v-if="orderIsActif && !item.isNotAvailableOnline"
      @click.stop="$emit('toggleModal', item, sectionId)"
    >
      <img src="@/assets/icons/add-p.svg"  style="height: 20px; width: 20px;" />
    </div>

    <div
      :class="['overlay-brunch', { expanded: item.showDetails }]"
      :style="{backgroundColor: menu.titleItemBackgroundColor || 'inherit',}" 
      @click="toggleDescription(item)"
    >
      <div class="action-infos">
        <div class="top-action"></div>
        <div v-if="item && item.description">
          <img
            src="@/assets/icons/angle-up.svg"
            height="25"
            class="ml-2"
            :class="{ 'rotate-180': item.showDetails }"
            style="transition: transform 0.3s ease; height: 25px; width: 25px; "
          />
        </div>
      </div>

      <div :class="currentLang === 'ar' ? 'text-right' : 'text-left'" class="mb-2">
        <span
          :class="item.showDetails ? '' : 'line-clamp-1'"
          :style="itemStyle"
        >
          {{ item.name }}
        </span>
      </div>

      <transition  mode="out-in">
        <div
          class="detail-box"
          :class="currentLang === 'ar' ? 'text-right' : 'text-left'"
          v-if="item.showDetails"
          v-html="formattedDescription"
          :style="descStyle"
        ></div>
      </transition>

      <span class="price-text" :style="priceStyle">{{ item.price }}</span>
    </div>
  </span>
</template>

<script>
export default {
  name: "MenuItemCard",
  props: {
    item: { type: Object, required: true },
    sectionId: { type: [String, Number], required: true },
    withImage: { type: Boolean, default: false },
    orderIsActif: { type: Boolean, default: false },
    currentLang: { type: String, default: 'fr' },
    menu: { type: Object, default: () => ({}) },
    isInWishlist: { type: Function, required: true },
  },
  computed: {
    formattedDescription() {
      return this.item && this.item.description
        ? this.item.description.replace(/\n/g, "<br/>")
        : "-";
    },

    itemStyle() {
      return {
        fontFamily: this.menu.productFontFamily || "inherit",
        color: this.menu.productFontColor || "inherit",
        fontSize: this.menu.productFontSize || "inherit",
        fontWeight: this.menu.productFontWeight || "inherit",
        fontStyle: this.menu.productFontStyle || "inherit",
        textDecoration: this.menu.productTextDecoration || "inherit",
      };
    },
    descStyle() {
      return {
        fontFamily: this.menu.productFontFamily || "inherit",
        fontWeight: this.menu.productFontWeight || "inherit",
        color: this.menu.itemDescriptionColor || "inherit",

      };
    },
    priceStyle() {
      return {
        fontFamily: this.menu.productFontFamily || "inherit",
        fontWeight: this.menu.productFontWeight || "inherit",
        color: this.menu.productFontColor || "inherit",
      };
    },
  },
  methods: {

    toggleDescription(item) {
        if(item && item.description){
            item.showDetails = !item.showDetails;
        }
    },
  },
};
</script>


<style scoped>
/* Wrapper & layout */
.item {
  display: inline-block;
  flex: 0 0 auto;
  scroll-snap-align: start;
  position: relative;
  min-width: 230px;
  height: 100%;
  background: transparent;
  border-radius: 5px;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  margin: 10px;
  margin-bottom: 10px;
  z-index: 99;
}

/* Image */
.wishlist-img,
.item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}


.overlay-brunch {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: white;
  opacity: 1;
  transform: translateY(0);
  transition: min-height 0.5s ease;
  padding: 0 1rem 1rem 1rem;
  min-height: 5px;
  max-height: 120px;
  overflow: hidden;
  border-radius: 0 0 5px 5px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1), 0 1px 3px rgba(0,0,0,0.06);
}

.overlay-brunch.expanded {
  min-height: 100%;
  border-top: 2px solid #000;
  box-shadow: 0 8px 14px rgba(0,0,0,0.2);
  opacity: 0.95;
}


/* Action info bar */
.action-infos {
  width: 100%;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.action-infos .top-action {
  width: 20px;
  height: 2px;
  background-color: #12151c;
  opacity: 0.2;
}

/* Icons */
.heart-icon {
  position: absolute;
  top: 0;
  right: 0;
  padding: 10px;
  cursor: pointer;
  z-index: 10;
}

.add-to-cart-icon-in-image {
  background-color: #c8e2cd;
  border-radius: 50%;
  position: absolute;
  top: 72%;
  right: 3%;
  padding: 8px;
  cursor: pointer;
  touch-action: manipulation; 
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
}

.multi-image-icon {
  position: absolute;
  top: 5px;
  left: 0;
  padding: 10px;
  cursor: pointer;
}

/* Text & Price */
.price-text {
  bottom: 0;
  right: 0;
  padding: 10px 15px 5px 15px;
  position: absolute;
  color: #000;
}

.line-clamp-1 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: block;
}

.rotate-180 {
  transform: rotate(180deg);
  transition: transform 0.5s ease-in-out;
}

/* Optional: support RTL */
.text-right {
  text-align: right;
}
.text-left {
  text-align: left;
}
</style>
